module.exports = __webpack_public_path__ + "static/img/Pic-msd.1289636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/Pic-msd.png
// module id = FasG
// module chunks = 63